// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import * as React from 'react';

const LoggedInContext = React.createContext<LoggedInContextType | undefined>(undefined);

interface LoggedInContextType {
  readonly isLoggedIn: boolean;
  readonly setIsLoggedIn: (newIsLoggedIn: boolean) => void;
}

export interface InitialLoggedInState {
  readonly isLoggedIn: boolean;
}

export const useLoggedInState = (): LoggedInContextType => {
  const context = React.useContext(LoggedInContext);
  if (context === undefined) {
    throw new Error('useLoggedInState must be used within a LoggedInStateProvider');
  }
  return context;
};

export function LoggedInStateProvider({
  initialState,
  children,
}: {
  readonly initialState: InitialLoggedInState;
  readonly children: React.ReactNode;
}) {
  const [isLoggedIn, setIsLoggedIn] = React.useState(initialState.isLoggedIn);
  return <LoggedInContext.Provider value={{ isLoggedIn, setIsLoggedIn }}>{children}</LoggedInContext.Provider>;
}
